import React, { Component } from 'react';
import logo from './images/logo.png';
import './App.css';
import { HashRouter as Router, Route } from 'react-router-dom';
import ResetPasswordRequest from './containers/ResetPasswordRequest/ResetPasswordRequest';
import ResetPassword from './containers/ResetPassword/ResetPassword';

class App extends Component {
  render() {
    return (
      <Router>
        <div>
          <div className='header'>
            <img className='logo' src={logo} alt='logo' />
          </div>

            <Route exact path='/' component={ResetPasswordRequest} />
            <Route path="/reset/:token" component={ResetPassword} />
        </div>
      </Router>      
    );
  }
}

export default App;
